import { AfterViewInit, Component, OnInit } from '@angular/core';

import { AbstractValueControlBase } from '../../types/abstract-value-control-base';
import { ControlTypeName } from '../../types/control-type-name';
import { ControlValidateMoment } from '../../types/validator.types';
import { isJSON } from '../../utils/utils';

@Component({
  selector: 'df-car',
  templateUrl: './car-type.component.html',
  styleUrls: ['./car-type.component.scss']
})
export class CarTypeComponent extends AbstractValueControlBase<any> implements OnInit, AfterViewInit {
  type = ControlTypeName.carType;

  brand: any;
  result: any;
  carInfo: any;
  showResult: string;

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  getModelValue() {
    if (!this.model.value) {
      return {
        // brand: '',
        // brandId: '',
        // carSeries: '',
        // carSeriesId: '',
        // carType: '',
        // carTypeId: '',
        brand: null,
        brandId: null,
        carSeries: null,
        carSeriesId: null,
        carType: null,
        carTypeId: null
      };
    }
    return this.model.value;
  }

  setModelValue(val: any) {
    if (!val) {
      this.model.value = '';
      this.carInfo = {};
    } else {
      if (typeof val === 'string' && isJSON(val)) {
        val = JSON.parse(val);
      }
      this.model.value = val;
      this.carInfo = val;
    }
    this.setShowResult();
  }

  outPutResultChange($event: any) {
    this.result = {
      brand: $event.carBrandName,
      brandId: $event.carBrandId,
      carSeries: $event.carSeriesName,
      carSeriesId: $event.carSeriesId,
      carType: $event.carModelInfo.mosaicName,
      carTypeId: $event.carModelInfo.id
    };
    this.model.value = this.result;
    this.validateAtMoment(ControlValidateMoment.Input);
    this.validateAtMoment(ControlValidateMoment.Change);

    this.broadControlValueChange();
  }

  setShowResult() {
    if (!this.model.value) {
      this.showResult = '';
      return;
    }
    this.showResult =
      this.getTypeText('brand', '') + '/' + this.getTypeText('carSeries', '') + '/' + this.getTypeText('carType', '');
  }

  private getTypeText(name: string, defaultValue: string) {
    const value = this.model.value[name];
    if (!value) {
      return defaultValue;
    }
    return value;
  }
}
